/* tslint:disable */
/* eslint-disable */

/**
 * type of raster
 */
export enum RasterCatCode {
  Base = 'BASE',
  Dist = 'DIST',
  Gravel = 'GRAVEL',
  Other = 'OTHER',
  Level = 'LEVEL',
  Compact = 'COMPACT'
}
